"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var useCheckValueInterval = function useCheckValueInterval(completeAction, intervalAction, shouldRunInterval, intervalTime, maxIteration) {
  var iteration = 0;
  var interval = undefined;
  (0, react_1.useEffect)(function () {
    if (shouldRunInterval) {
      interval && clearInterval(interval);
      clearInterval(interval);
      interval = window && window.setInterval(function () {
        iteration++;
        intervalAction && intervalAction(iteration);

        if (iteration === maxIteration) {
          clearInterval(interval);
          completeAction && completeAction();
        }
      }, intervalTime);
    } else {
      interval && clearInterval(interval);
    }

    return function () {
      return clearInterval(interval);
    };
  }, [shouldRunInterval]);
};

exports.default = useCheckValueInterval;